module.exports = __webpack_public_path__ + "static/img/chengduwei.c736657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chengduwei.png
// module id = ga58
// module chunks = 1